import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import App from './App.tsx';
import { enableMocking } from './shared/utils/enableMocking.ts';

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
